export default "__VITE_ASSET__BzFJe7oQ__"